import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import FormCreator from "../../common/FormCreator";
import history from "../../history";
import {
  authorityForPaymentsSubmitted,
  postAuthorityForPaymentsForm,
} from "../../redux/actions/formActions";
import HorizontalLine from "../../common/HorizontalLine";

const AuthorityForPaymentsAssesment = ({
  appData,
  postAuthorityForPaymentsFormFunc,
  setAuthorityForPaymentsSubmitted,
}) => {
  const initialName = `${appData.firstName} ${appData.lastName}`;

  const initialData = {
    firstname: appData.firstName,
    surname: appData.lastName,
    title: appData.title,
    dob: appData.dateOfBirth
      ? moment(new Date(appData.dateOfBirth)).format("DD/MM/YYYY")
      : "",
    namePD: initialName,
    datePD: moment().format("DD/MM/YYYY"),
    name: initialName,
    date: moment().format("DD/MM/YYYY"),
    signature: initialName,
  };
  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const validateAccountNumber = (value) => {
    if (!value) {
      return true;
    }
    if (/^(\d){8}$/.test(value)) {
      return true;
    }
    return false;
  };

  const validateSortCode = (value) => {
    if (!value) {
      return true;
    }
    if (/^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/.test(value)) {
      return true;
    }
    return false;
  };

  const initialState = {
    title: "",
    firstNameSurname: {
      title: `I ${getVal("firstname")} ${getVal(
        "surname"
      )} authorise my wages to be paid into a bank account that is not opened in my own name. `,
    },
    accountHolder: {
      title: "Name of account holder",
      value: "",
      mandatory: true,
    },
    bank: {
      title: "Bank",
      value: "",
      mandatory: true,
    },
    accountNumber: {
      title: "Account number",
      mandatory: true,
      validate: validateAccountNumber,
      value: "",
    },
    sortCode: {
      title: "Sort code",
      mandatory: true,
      validate: validateSortCode,
      value: "",
    },
    relationship: {
      title: "Relationship to temporary worker",
      value: "",
      mandatory: true,
    },
    section2: {
      htmlObj: (
        <HorizontalLine
          text="Declaration"
          desc="I am aware that I am required to open a bank account in my own name as soon as it is possible and will inform HRGO in writing of my new detail's"
        />
      ),
    },
    signature: {
      title: "Signature of temporary worker",
      type: "text",
      value: `${getVal("firstname")} ${getVal("surname")}`,
      mandatory: true,
    },
    nameOfTemporaryWorker: {
      title: "Name of temporary worker (PRINTED)",
      type: "text",
      value: `${getVal("firstname")} ${getVal("surname")}`,
      mandatory: true,
    },
    date: {
      title: "Date",
      type: "text",
      value: getVal("date"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    setAuthorityForPaymentsSubmitted();
    postAuthorityForPaymentsFormFunc(
      "authorityForPaymentsAssessment",
      formCreatorConvertToValues({
        ...fields,
        firstNameSurname: {
          value: `${getVal("firstname")} ${getVal("surname")}`,
        },
      })
    );
    history.push("/profile/edit/resources");
  };
  return (
    <FormCreator
      formTitle={"Authority for Payment of Wages into a 3rd Party Bank Account"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/resources")}
    />
  );
};

AuthorityForPaymentsAssesment.propTypes = {
  appData: any,
  postAuthorityForPaymentsFormFunc: func.isRequired,
  setAuthorityForPaymentsSubmitted: func,
};
const mapDispatchToProps = {
  postAuthorityForPaymentsFormFunc: postAuthorityForPaymentsForm,
  setAuthorityForPaymentsSubmitted: authorityForPaymentsSubmitted,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(AuthorityForPaymentsAssesment);
